export default "__VITE_ASSET__ab22677c__"